<template>
  <form class="header__search-form">
    <input v-model="query" @input="searchAutocomplete()" class="form-control header__search-input" type="search" placeholder="Поиск продукта" aria-label="Search">
    <button class="btn header__search--btn" type="submit">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6.5" cy="6.5" r="6" stroke="#2F324E"/>
        <path d="M11 11L15 15" stroke="#2F324E" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    <ul class="dropdown-autocomplete" v-if="search_results && search_results.length > 0">
        <li 
          v-for="(item, index) in search_results" 
          :key="item.id"
          class="dropdown-autocomplete__item" 
        >
          <a v-bind:href="item.get_absolute_url">{{ item.title }}</a>
        </li>
    </ul>
  </form>
</template>

<script>
import axios from 'axios'


export default {
  name: 'SearchProduct',
  data() {
    return {
      search_results: null,
      request_process: false,
      query: ''
    }
  },
  mounted() {
  },
  methods: {
    searchRequest: function () {
      if(this.query.length > 1 && !this.request_process){
        this.request_process = true
          axios.get("/catalog/api/search/?query="+this.query).then(response => {
              this.search_results = response.data
              this.request_process = false
            }
          );
      }
    },
    searchAutocomplete: function(){
      setTimeout(
        () => 
        this.searchRequest(), 
      500)
    }
  }
}
</script>

<style lang="scss">
</style>
